// Synchronous code -- commits change data directly

const mutations = {
    referentialMutation(state, payload) {
        // if(!payload || !payload.result) {
        //     console.warn("No payload or payload.result provided to referentialMutation")
        //     state.referentialData = []
        //     return
        // }
        const incoming = Array.isArray(payload.result) ? payload.result : []
        //console.log("incoming data : ", incoming)
        if (state.referentialData.length === 0) {
            // If empty, just populate
            state.referentialData = [...incoming]
            // //console.log("state value", state.referentialData)
            // Add RC/RE flags
            const rolesMap = {};
            if (Array.isArray(payload.roles)) {
                payload.roles.forEach(roleObj => {
                    rolesMap[roleObj.referential] = roleObj.roles;
                });
            }
            state.referentialData.forEach(ref => {
                const roles = rolesMap[ref.referentiel_id] || [];
                ref.RC = roles.includes("RC");
                ref.RE = roles.includes("RE");
            });
            // //console.log("state value", state.referentialData)
            return
        }

        // Build a map for quick lookup
        // const incomingMap = new Map(incoming.map(item => [item.referentiel_id, item]))
        const currentMap = new Map(state.referentialData.map(item => [item.referentiel_id, item]))

        // Update existing and add new
        const updatedData = []
        for (const item of incoming) {
            const existing = currentMap.get(item.referentiel_id)
            if (!existing) {
                // New item, add it
                updatedData.push({ ...item })
            } else {
                // Existing item, update only if changed (shallow compare, can be deep if needed)
                const hasChanged = Object.keys(item).some(key => item[key] !== existing[key])
                updatedData.push(hasChanged ? { ...item } : existing)
            }
        }

        // Remove items not present in incoming
        // (optional: if you want to keep items that are not in the new data, skip this step)
        // If you want to keep local edits for items not in incoming, you can merge them here

        state.referentialData = updatedData

        const rolesMap = {};
        if (Array.isArray(payload.roles)) {
            payload.roles.forEach(roleObj => {
                rolesMap[roleObj.referential] = roleObj.roles;
            });
        }
        state.referentialData.forEach(ref => {
            const roles = rolesMap[ref.referentiel_id] || [];
            ref.RC = roles.includes("RC");
            ref.RE = roles.includes("RE");
        });
    },

    referentialProductionMutation(state, payload) {
        // //console.log("Production mutation with payload ", payload);
        // Filter only items with status "PRODUCTION"
        state.referentialData = Array.isArray(payload.result)
            ? payload.result.filter(item => item.status === "RELEASE")
            : [];

        // //console.log("Filtered state value", state.referentialData);
    },

    loadTreeMutation(state, payload) {
        // //console.log("Mutation launched with payload", payload);
        // Add `collapsed: true` to each element in the payload
        // state.criteriaTree = Array.isArray(payload)
        //     ? payload.map(criteria => ({
        //         ...criteria,
        //         collapsed: false, // Default value for collapsed
        //     }))
        //     : [];

        //console.log("state criteriaValue", state.criteriaTree, payload);
        const incoming = Array.isArray(payload)
            ? payload.map(criteria => ({
                ...criteria,
                collapsed: false, // Default value for collapsed
            }))
            : [];

        if (state.criteriaTree.length === 0) {
            state.criteriaTree = [...incoming];
            //console.log("state criteriaValue", state.criteriaTree);
            return;
        }
        //console.log("criteriaTree before update", state.criteriaTree);
        const currentMap = new Map(state.criteriaTree.map(item => [item.id, item]));
        const updatedData = [];
        for (const item of incoming) {
            const existing = currentMap.get(item.id);
            if (!existing) {
                updatedData.push({ ...item });
            } else {
                // Only update if changed (shallow compare)
                const hasChanged = Object.keys(item).some(key => item[key] !== existing[key]);
                updatedData.push(hasChanged ? { ...item } : existing);
            }
        }
        state.criteriaTree = updatedData;
    },
    loadTreeQuestionMutation(state, payload) {

        const incoming = Array.isArray(payload) ? [...payload] : [];
        if (state.questionTree.length === 0) {
            state.questionTree = [...incoming];
            return;
        }

        const currentMap = new Map(state.questionTree.map(item => [item.id, item]));
        const updatedData = [];
        for (const item of incoming) {
            const existing = currentMap.get(item.id);
            if (!existing) {
                updatedData.push({ ...item });
            } else {
                const hasChanged = Object.keys(item).some(key => item[key] !== existing[key]);
                updatedData.push(hasChanged ? { ...item } : existing);
            }
        }
        state.questionTree = updatedData;

        // //console.log("Question mutation launched with payload ", payload)
        // state.questionTree = Array.isArray(payload) ? [...payload] : []
    },
    selectTreeMutation(state, payload) {
        // //console.log("selecting tree: ", payload)
        state.selectedReferential = parseInt(payload)
        if(payload === 0) {
            state.criteriaTree = []
            state.questionTree = []
            state.canEditList = [
                {"referentialTitle": true}, 
                {"referentialDescription": true}, 
                { 'referentialCreatorOpen': false},
                { 'criteriaEditorOpen': false},
                { 'questionEditorOpen': false},
                { 'confirmationDialogOpen': false},
                { 'projectModalOpen': false},
            ]
            state.activeCriteria = []
            state.activeQuestion = []
            state.callerObject = []
            state.confirmationObject = []
            state.loading = false
            state.referentialDatabase = []
            state.generalDataConfig = []
            state.questionTags = []
            state.evaluationTags = []
            // state.userList = []
            state.userListRightsReferential = []
            // state.numberProjects = []
            state.referentialErrors = {}
            state.userListRightsProject = []
            state.unlockStatus = false
            state.pdf = []
        }
    },
    toggleEditRerentialTitleMutation(state, payload) {
        //console.log("toggling title edit to", payload)
        state.canEditList.referentialTitle = payload
    },
    toggleEditRerentialDescriptionMutation(state, payload) {
        //console.log("toggling description edit to", payload)
        state.canEditList.referentialDescription = payload
    },
    toggleReferenentialModalNew(state, payload) {
        //console.log("Toggling visibility of modal to create new referential", payload)
        state.canEditList.referentialCreatorOpen = payload
    },
    updateReferentialStatusMutation(state, payload) {
        // //console.log("Updating referential status", payload)
        state.referentialData = state.referentialData.map(item => {
            if (Number(item.referentiel_id) === Number(payload.id)) {
                // //console.log("Updating item", item)
                // //console.log("With new status:", payload.status)
                return { ...item, status: payload.status };
            }
            return item;
        })
    },
    unlockStatus(state, payload){
        ////console.log("unlockStatus : ", payload)
        state.unlockStatus = payload
    },
    toggleCriteriaModal(state, payload) {
        //console.log("Toggling visibility of modal to edit a criteria", payload)
        state.canEditList.criteriaEditorOpen = payload
    },
    makeCriteriaActiveMutation(state, payload) {
        state.activeCriteria = payload
    },
    updateCriteriaOrderMutation(state, newOrder) {
        state.criteriaTree = newOrder; // Save new order in state
    },
    addCriteriaMutation(state, newCriteria) {
        if(newCriteria.parent) {
            const parent = state.criteriaTree.find(item => item.id === newCriteria.parent)
            if(parent) {
                // parent.children_ids.push(newCriteria.id)
                // parent.children_ids = [...state.criteriaTree, newCriteria]
                parent.children_ids = [...parent.children_ids, newCriteria.id]
            }
        }
        state.criteriaTree = [...state.criteriaTree, newCriteria]
        // state.criteriaTree.push(newCriteria)
    },
    updateCriteriaMutation(state, { id, updatedData }) {
        const index = state.criteriaTree.findIndex(criteria => criteria.id === id);
        //console.log(`searching for id ${id} and found index ${index}`)
        
        if (index === -1) {
            console.error(`Criteria with id ${id} not found in criteriaTree`)
            return
        }
        const criteria = state.criteriaTree[index]
        const oldParentId = criteria.parent
        const newParentId = updatedData.parent; // Get new parent ID
        
        // 1. Update the criteria with new data
        state.criteriaTree[index] = { ...state.criteriaTree[index], ...updatedData };
        ////console.log("After update:", state.criteriaTree[index]); // Check if it remains defined

        // 2. Remove ID from old parent’s children_ids (if parent changed)
        if (oldParentId !== newParentId) {
            const oldParent = state.criteriaTree.find(item => item.id === oldParentId);
            if (oldParent) {
                oldParent.children_ids = oldParent.children_ids.filter(childId => childId !== id);
            }
        }

        // 3. Add ID to new parent’s children_ids
        if (newParentId) {
            const newParent = state.criteriaTree.find(item => item.id === newParentId);
            if (newParent) {
                newParent.children_ids = [...newParent.children_ids, id]; // New reference ensures Vue reactivity
            }
        }
    },
    removeCriteriaMutation(state, id) {
        // Find the criteria to delete
        const criteriaToDelete = state.criteriaTree.find(item => item.id === id);
        if (!criteriaToDelete) return; // Exit if not found

        // Remove its ID from its parent’s `children_ids`
        if (criteriaToDelete.parent) {
            const parent = state.criteriaTree.find(item => item.id === criteriaToDelete.parent);
            if (parent) {
                parent.children_ids = parent.children_ids.filter(childId => childId !== id);
            }
        }

        // Remove the criteria itself from `criteriaTree`
        state.criteriaTree = state.criteriaTree.filter(item => item.id !== id);

        //console.log(`Deleted criteria ${id} and updated tree`);
    },
    removeCriteriaMutation_DELETING_CHILDREN_TOO(state, id) {
        const findAndDelete = (criteriaId) => {
            // Find the criteria
            const criteriaToDelete = state.criteriaTree.find(item => item.id === criteriaId);
            if (!criteriaToDelete) return;

            // Remove this criteria from its parent's children_ids
            if (criteriaToDelete.parent) {
                const parent = state.criteriaTree.find(item => item.id === criteriaToDelete.parent);
                if (parent) {
                    parent.children_ids = parent.children_ids.filter(childId => childId !== criteriaId);
                }
            }

            // Recursively delete children
            criteriaToDelete.children_ids.forEach(childId => findAndDelete(childId));

            // Remove the criteria itself from `criteriaTree`
            state.criteriaTree = state.criteriaTree.filter(item => item.id !== criteriaId);
        };

        findAndDelete(id);
    },
    addQuestionMutation(state, newQuestion) {
        //console.log("Before adding question", state.questionTree)
        //console.log("Adding question", newQuestion)
        state.questionTree = [...state.questionTree, newQuestion]
        //console.log("After adding question", state.questionTree)
    },
    updateQuestionMutation(state, { id, updatedData }) {
        const index = state.questionTree.findIndex(question => question.id === id);
        //console.log(`searching for id ${id} and found index ${index}`)
        
        if (index === -1) {
            console.error(`Question with id ${id} not found in questionTree`)
            return
        }
        // const question = state.questionTree[index]
        
        // 1. Update the question with new data
        state.questionTree[index] = { ...state.questionTree[index], ...updatedData };
        //console.log("After update:", state.questionTree[index]); // Check if it remains defined

    },
    removeQuestionMutation(state, id) {
        // Find the criteria to delete
        const questionToDelete = state.questionTree.find(item => item.id === id);
        if (!questionToDelete) return; // Exit if not found

        // Remove the Question itself from `questionTree`
        state.questionTree = state.questionTree.filter(item => item.id !== id);

        //console.log(`Deleted question ${id} and updated tree`);
    },
    toggleQuestionModal(state, payload) {
        //console.log("Toggling visibility of modal to edit a question", payload)
        state.canEditList.questionEditorOpen = payload
    },
    makeQuestionActiveMutation(state, payload) {
        state.activeQuestion = { ...payload };
    },
    callerSetMutation(state, payload) {
        state.callerObject = payload
    }, 
    loadingMutation(state, payload) {
        if(state.loading != payload){
        //console.log("loadingMutation Ref=> state",state.loading,"\npayload", payload)
        state.loading = payload
        }
    },
    returnConfirmationObjectMutation(state, payload) {
        //console.log("returning confirmation object", payload)
        state.confirmationObject = payload
        state.canEditList.confirmationDialogOpen = true
    },
    returnConfirmationCloseMutation(state) {
        state.canEditList.confirmationDialogOpen = false
        state.confirmationObject = []
    },
    loadTreeDatabaseMutation(state, payload) {
        //console.log("Database mutation launched with payload ", payload)
        const sorted = Array.isArray(payload) ? 
            payload.slice().sort((a, b) => { 
                if(a.locationChapter < b.locationChapter) return -1;
                if(a.locationChapter > b.locationChapter) return 1;
                return a.view_order - b.view_order
            }) : [];
        state.referentialDatabase = sorted
        //console.log("state.referentialDatabase value", state.referentialDatabase)
        // state.referentialDatabase = Array.isArray(payload) ? [...payload] : []
    },
    updateDatabaseMutation(state, { index, updatedData }) {
        
        if (index === -1) {
            console.error(`database with id ${updatedData.tag} not found in database`)
            return
        }
        state.referentialDatabase[index] = { ...state.referentialDatabase[index], ...updatedData };
        //console.log("After update:", state.referentialDatabase[index]); // Check if it remains defined
    },
    updateReferentialSingleValueMutation(state, { tag, value, index }) {
        //console.log("Updating referential single value", tag, value, index)
        const firstIndex = state.referentialDatabase.findIndex(item => item.tag === tag)
        // //console.log("firstIndex", firstIndex)
        if (firstIndex === -1) {
            console.error(`Variable with tag ${tag} not found in referentialData`)
            return
        }
        //console.log("referentialDatabase before update:", firstIndex, state.referentialDatabase[firstIndex])
        // Update the specific variable in referentialData
        // state.referentialDatabase[firstIndex] = { ...state.referentialDatabase[firstIndex].values[index], value };
        if(index === -1) {
            //console.log("update index === -1 :", state.referentialDatabase[firstIndex].value, "\tvalue :", value)
            state.referentialDatabase[firstIndex].value = value;
        } else {
            //console.log("update else :", state.referentialDatabase[firstIndex].value, "\tvalue :", value)
            state.referentialDatabase[firstIndex].values[index] = value;
        }

        // dispatch("referential/updateReferentialDatabase", {
        //     index: index,
        //     database: state.referentialDatabase[firstIndex],
        //     type: 'array',
        // });

        //console.log("Updated referentialData:", state.referentialDatabase[firstIndex])
    },
    generalDataConfigMutation(state, payload) {
        //console.log("generalDataConfig mutation launched with payload ", payload)
        state.generalDataConfig = Array.isArray(payload) ? [...payload] : []
    },
    questionTagsMutation(state, payload) {
        ////console.log("questionTags mutation launched with payload ", payload)
        state.questionTags = Array.isArray(payload) ? [...payload] : []
    },
    evaluationTagsMutation(state, payload) {
        ////console.log("evaluationTags mutation launched with payload ", payload)
        state.evaluationTags = Array.isArray(payload) ? [...payload] : []
    },
    collapseCriteriaMutation(state, payload) {
        //console.log("collapsing criteria with id", payload)
        const criteria = state.criteriaTree.find(item => item.id === payload)
        if(criteria) {
            criteria.collapsed = !criteria.collapsed
        }
    }, 
    userListMutation(state, payload) {
        //console.log("userList mutation launched with payload ", payload)
        // state.userList = Array.isArray(payload) ? [...payload] : []
        state.userList = Array.isArray(payload.result) ? [...payload.result] : []
    },
    userListRightsReferentialMutation(state, payload) {
        //console.log("userListRightsReferential mutation launched with payload ", payload)
        // state.userList = Array.isArray(payload) ? [...payload] : []
        state.userListRightsReferential = Array.isArray(payload.result) ? [...payload.result] : []
    },
    toggleProjectCreatorModal(state, payload) {
        //console.log("Toggling visibility of modal to create new project", payload)
        state.canEditList.projectModalOpen = payload.open
    }, 
    updateUserAccessMutation(state, { user, type, checked }) {
        let search = state.userListRightsReferential.find(search => search.user_id === user.user_id)
        //console.log("Updating user access", user, type, checked, "\nsearch :" ,search)
        if (search) {
            if (checked) {
                if (!search.roles.includes(type)) {
                    search.roles = search.roles ? `${search.roles},${type}` : type
                }
            } else {
            search.roles = search.roles
                .split(',')
                .filter(r => r && r !== type)
                .join(',')
            }
            if (!search.roles) {
            const idx = state.userListRightsReferential.findIndex(r => r.user_id === user.user_id)
            if (idx !== -1) state.userListRightsReferential.splice(idx, 1)
        }
        } else if (checked && type !== 'admin') {
            state.userListRightsReferential.push({ user_id: user.user_id, roles: type })
        } else if (type === 'admin') {
            const userToUpdate = state.userList.find(u => u.user_id === user.user_id);
            if (userToUpdate) {
                // Update the admin role for the user
                userToUpdate.adminRole = checked ? 1 : 0;
            }
            //console.log("change admin role for user", user.user_id, checked)
        } else {
            // User not found, add new entry
            let roles = "";
            if (checked) {
                roles = type;
            }
            state.userListRightsReferential.push({
                user_id: user.user_id,
                roles
            });
            //console.log("Added new user to userListRightsReferential:", user.user_id, roles);
        }
        //console.log("list after update", state.userListRightsReferential)
    },
    updateUserAccessProjectMutation(state, { user, type, checked }) {
        //console.log("Updating user access", user, type, checked)
        //console.log("userListRightsProject before update", state.userListRightsProject)
        let search = state.userListRightsProject.find(search => search.user_id === user.user_id)
        if (search) {
            if (search && !search.roles) {
                state.userListRightsProject = state.userListRightsProject.filter(r => r.user_id !== user.user_id)
            }
            if (type === 'PE') {
                if (checked) {
                    search.roles = search.roles ? search.roles + ",PE" : "PE"
                } else {
                    search.roles = search.roles.replace(/PE/g, "").replace(/,,/g, ",").replace(/^,|,$/g, "")
                }
            }
        if (!search.roles || search.roles.trim() === '') {
            state.userListRightsProject = state.userListRightsProject.filter(r => r.user_id !== user.user_id)
        }
        } else {
            let roles = "";
            if (checked) {
                roles = type;
            }
            state.userListRightsProject.push({
                user_id: user.user_id,
                roles
            });
             //console.log("Added new user to userListRightsProject:", user.user_id, roles);
        }
        //console.log("list after update", state.userListRightsProject)
    },
    projectStatusMutation(state, { referential_id, statusData }) {
        if (!state.projectStatusByReferential) state.projectStatusByReferential = {}
        state.projectStatusByReferential[referential_id] = statusData
        // //console.log("Project status only for selected referential?", referential_id, state.selectedReferential)
        if(state.selectedReferential === referential_id) {
            state.numberProjects = statusData
            // //console.log("state.numberProjects", state.numberProjects)
        }
    },
    validatorListMutation(state, payload) {
        //console.log("validatorList mutation launched with payload ", payload)
        // state.userList = Array.isArray(payload) ? [...payload] : []
        state.userListRightsProject = Array.isArray(payload.result) ? [...payload.result] : []
        //console.log("state.userListRightsProject", state.userListRightsProject)
    },
    toggleFactorFilter(state) {
        state.filterFactorOneActive = !state.filterFactorOneActive
    },
    referentialValidateMutation(state, payload) {
        //console.log("referentialErrors mutation launched with payload ", payload)
        state.referentialErrors = Array.isArray(payload) ? [...payload] : []
    },
    clearReferentialState(state) {
        //console.log("clearReferentialState")
        state.referentialData = []
        state.selectedReferential = 0
        state.criteriaTree = []
        state.questionTree = []
        state.canEditList = [
            {"referentialTitle": true}, 
            {"referentialDescription": true}, 
            { 'referentialCreatorOpen': false},
            { 'criteriaEditorOpen': false},
            { 'questionEditorOpen': false},
            { 'confirmationDialogOpen': false},
            { 'projectModalOpen': false},
        ];
        state.activeCriteria = []
        state.activeQuestion = []
        state.callerObject = []
        state.confirmationObject = []
        state.loading = false
        state.referentialDatabase = []
        state.generalDataConfig = []
        state.questionTags = []
        state.evaluationTags = []
        state.userList = []
        state.userListRightsReferential = []
        state.numberProjects = []
        state.referentialErrors = {}
        state.userListRightsProject = []
        state.unlockStatus = false
        state.pdf = []
    },
    createPDFMutation(state, payload){
        state.pdf = payload;
    },
}

export default mutations;

